<template>
    <div v-if="getTechLevel">
        <tech-level-header page-name="個人一覧"></tech-level-header>
        <tech-level-input></tech-level-input>
        <tech-level-list v-show="show"></tech-level-list>
    </div>
</template>

<script>
    import TechLevelHeader from 'pages/commons/header/Header'
    import TechLevelInput from './components/Input'
    import TechLevelList from './components/List'

    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                show: true
            }
        },
        components: {
            TechLevelHeader,
            TechLevelInput,
            TechLevelList
        },
        created () {
            this.loadTechLevel()
            this.resetRefresh('techLevel')
        },
        activated () {
            if (this.getRefreshArr['techLevel']) {
                this.loadTechLevel()
            }
            this.resetRefresh('techLevel')
        },
        watch: {
            getTechLevelLoadStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startProgress')
                }
                if (status == 2) {
                    this.$store.dispatch('doneProgress')
                }
                if (status == 3) {
                    this.$store.dispatch('doneProgress')
                }
            }
        },
        computed: {
            ...mapGetters(['getTechLevelLoadStatus', 'getTechLevel','getRefreshArr'])
        },
        methods: {
            resetRefresh (pageName) {
                this.$store.dispatch('resetRefreshArr', pageName)
            },
            loadTechLevel () {
                this.$store.dispatch('loadTechLevel')
            },
            toTechChild (code, name, level) {
                this.$router.push({name:'TechChild', params:{
                    code: code,
                    name: name,
                    level: level
                }})
            },
            showTechLevel () {
                this.show = true
            },
            hideTechLevel () {
                this.show = false
            },
        }
    }
</script>

<style></style>
